import { render, staticRenderFns } from "./MajorEvents.vue?vue&type=template&id=17b93cef&"
import script from "./MajorEvents.vue?vue&type=script&lang=js&"
export * from "./MajorEvents.vue?vue&type=script&lang=js&"
import style0 from "./MajorEvents.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports